<template>
  <div>
    <div class="pending-checkout">
      <h2 class="pending-checkout__title">
        {{ $t('profile.subscription.pendingCheckout.title') }}
      </h2>

      <p class="pending-checkout__caption">
        {{ $t('profile.subscription.pendingCheckout.caption') }}
      </p>

      <PlanCard
          v-if="plan != null"
          class="pending-checkout__plan"
          :plan="plan"
          active
          :discounted-price="coupon != null ? finalPrice : null"
      />

      <div
          class="pending-checkout__summary"
          v-if="coupon != null"
      >
        <div class="pending-checkout__summary-row">
                <span class="pending-checkout__label">
                    {{ $t('profile.subscription.pendingCheckout.discount') }}
                </span>

          <span class="pending-checkout__value">
                    -{{ coupon.discount_percentage }}%
                </span>
        </div>
      </div>

      <div class="pending-checkout__actions">
        <vs-button
            size="large"
            border
            block
            @click="callback(true, true)"
        >
          {{ $t('profile.subscription.pendingCheckout.keep') }}
        </vs-button>

        <vs-button
            size="large"
            block
            @click="callback(false, true)"
        >
          {{ $t('profile.subscription.pendingCheckout.discard') }}
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import PlanCard from '../elements/PlanCard.vue';

export default {
  name: "pendingCheckoutDialog",

  // widens this dialog via DialogWrapper's vs-dialog `width` prop, so the
  // discard/keep button labels stay on a single line (see DialogWrapper.vue)
  dialogWidth: '640px',

  components: {
    PlanCard
  },

  props: {
    callback: Function,
    data: Object
  },

  computed: {
    plan() {
      return this.data != null ? this.data.plan : null;
    },

    coupon() {
      return this.data != null ? this.data.coupon : null;
    },

    finalPrice() {
      if (this.plan == null || this.plan.price == null) {
        return '0.00';
      }

      const discount =
          this.coupon != null &&
          this.coupon.discount_percentage != null
              ? this.coupon.discount_percentage
              : 0;

      return (
          (this.plan.price / 100) *
          (1 - discount / 100)
      ).toFixed(2);
    }
  }
}
</script>

<style scoped>
.pending-checkout {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  width: 100%;
  padding: 40px 16px 0;
  box-sizing: border-box;
}

.pending-checkout__title,
.pending-checkout__caption {
  margin: 0;
  text-align: justify;
}

.pending-checkout__caption {
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.75);
}

.pending-checkout__plan {
  width: 100%;
}

.pending-checkout__plan::before {
  background: none;
}

.pending-checkout__summary {
  width: 100%;
  max-width: 420px;

  padding: 16px;

  border-radius: 12px;
  background: rgba(0, 0, 0, 0.04);

  display: flex;
  flex-direction: column;
  gap: 10px;

  box-sizing: border-box;
}

.pending-checkout__summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  font-size: 0.95rem;
}

.pending-checkout__label {
  color: rgba(0, 0, 0, 0.75);
}

.pending-checkout__value {
  text-align: right;
  font-weight: 500;
}

.pending-checkout__actions {
  display: flex;
  gap: 12px;
  width: 100%;
}

</style>